<script setup>
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'
    import { ref, computed } from 'vue'

    const props = defineProps({
        sws: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: () => false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Semester hours per week | Semesterwochenstunden' : 'Semesterwochenstunden'
    )

    const emit = defineEmits(['sws-saved'])
    const editValue = ref('')

    function handleEditStart() {
        editValue.value = props.sws
    }

    function handleEditAbort() {
        editValue.value = ''
    }

    const saveSws = () => {
        emit('sws-saved', editValue.value)
    }
</script>

<template>
    <single-edit
        :entry="sws"
        edit-key="sws"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
        @text-saved="saveSws"
    >
        <template #edit-component>
            <common-text-field v-model="editValue" density="default" class="w-100 h-100" />
        </template>
    </single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
